import { put, call, takeLatest, all } from 'redux-saga/effects';
import { processRequest } from '../../../../services/Api';
import { selectOwnerModalActionTypes } from './Constants';
import * as selectOwnerModalActions from './Actions';
import * as errorHandlerActions from '../../../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(selectOwnerModalActionTypes.SET_GROUP_OWNER, handleSetGroupManagerRequest),
	]);
}

export function* handleSetGroupManagerRequest({ payload }) {
	try {
		const { groupId, userId, callback } = payload || {};

		yield call(processRequest, `groups/${groupId}/promote_to_owner`, 'POST', {
			new_owner_id: userId,
		});

		if (callback) callback();

		yield put(selectOwnerModalActions.setGroupOwnerSuccess());
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(selectOwnerModalActions.setGroupOwnerError());
	}
}
